import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.search.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
import SessionStorage from 'quasar/src/plugins/SessionStorage.js';;
import { orderBy } from 'lodash';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog
  },
  data: function data() {
    return {
      phases: [],
      loading: true,
      searchText: '',
      pagination: {
        sortBy: 'project_count',
        descending: true,
        page: 1,
        rowsPerPage: 25,
        rowsNumber: 10
      },
      columns: [{
        name: 'name',
        field: 'name',
        label: this.$tc('general.name', 1),
        align: 'left',
        sortable: true
      }, {
        name: 'project_count',
        field: 'project_count',
        label: this.$tc('general.project', 2),
        align: 'right',
        sortable: true
      }]
    };
  },
  methods: {
    onRowClick: function onRowClick(event, row) {
      var _this = this;

      this.openDialog('PhaseDialog', {
        phaseName: row.name,
        onClose: function onClose() {
          _this.search();
        }
      });
    },
    resetSearch: function resetSearch() {
      this.searchParams = {};
      this.pagination = {
        sortBy: 'project_count',
        descending: true,
        page: 1,
        rowsPerPage: 50,
        rowsNumber: 10
      };
      this.search();
    },
    search: function search() {
      this.$refs.phasesTable.requestServerInteraction();
    },
    loadData: function loadData(props) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _props$pagination, page, rowsPerPage, sortBy, descending;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props$pagination = props.pagination, page = _props$pagination.page, rowsPerPage = _props$pagination.rowsPerPage, sortBy = _props$pagination.sortBy, descending = _props$pagination.descending;
                _this2.pagination = props.pagination;
                _this2.loading = true;
                SessionStorage.set('phases-table-search-params', _this2.searchParams);
                SessionStorage.set('phases-table-pagination', _this2.pagination);

                _this2.$axios.get('/phases', {
                  params: {
                    text: _this2.searchText,
                    page: page,
                    per_page: rowsPerPage === 0 ? 10000 : rowsPerPage,
                    sort_by: sortBy,
                    group_by: 'name',
                    direction: descending ? 'desc' : 'asc'
                  }
                }).then(function (response) {
                  _this2.phases = orderBy(response.data.data, [sortBy, 'name'], [descending ? 'desc' : 'asc', 'asc']);
                  _this2.pagination.rowsNumber = response.data.total;
                  _this2.pagination.page = response.data.current_page;
                  _this2.pagination.sortBy = sortBy;
                  _this2.pagination.descending = descending;
                  _this2.pagination.rowsPerPage = rowsPerPage;

                  _this2.$q.loading.hide();

                  _this2.loading = false;
                }).catch(function (response) {
                  _this2.loading = false;
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // following method is REQUIRED
    // (don't change its name --> "show")
    show: function show() {
      this.$refs.dialog.show();
    },
    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide: function hide() {
      this.$refs.dialog.hide();
    },
    onDialogHide: function onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    },
    onOKClick: function onOKClick() {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit('ok'); // or with payload: this.$emit('ok', { ... })
      // then hiding dialog

      this.hide();
    },
    onCancelClick: function onCancelClick() {
      // we just need to hide dialog
      this.hide();
    }
  },
  mounted: function mounted() {
    this.loadData({
      pagination: this.pagination,
      filter: null
    });
  }
};